/**
 * SLABadge — the small pill shown on the top-right of an SLA row.
 * Renders priceType-driven copy like "BEST PRICE" or "FASTER".
 */
import React, { FC } from 'react';
import classNames from 'classnames/bind';
import Text from '../../atoms/Text';
import { PRICE_TYPE, PriceType } from './constants';
import styles from './index.pcss';

const cx = classNames.bind(styles);

interface SLABadgeProps {
  label?: string;
  fleek?: boolean;
  /** B2C seller theme — priceType-tinted pill with dark copy. */
  b2c?: boolean;
  /** Drives the B2C tint; ignored outside the B2C theme. */
  priceType?: PriceType;
}

const SLABadge: FC<SLABadgeProps> = ({
  label = '',
  fleek = false,
  b2c = false,
  priceType = PRICE_TYPE.BEST
}) => {
  if (!label) return null;
  return (
    <span
      className={cx('sla-badge', {
        'sla-badge--fleek': fleek,
        'sla-badge--b2c': b2c,
        [`sla-badge--${priceType}`]: b2c
      })}
    >
      <Text
        variant="T1"
        weight="bold"
        color={fleek || b2c ? 'Nero' : 'White'}
        removeGrouping
        ariaHidden
      >
        {label}
      </Text>
    </span>
  );
};

export default SLABadge;
